import { Flex, Pane, TableV2, Text } from '@leverege/ui-elements'
import classNames from 'classnames'
import React from 'react'
import useShellsTable from '../hooks/useShellsTable'
import S from './ShellsTable.css'

function ShellsTable( { fgJob, isFullScreen } ) {
  const { data, columns } = useShellsTable( fgJob )

  return (
    <Pane variant="dashboardCardCustom" layout="flex:col" style={{ flex : 1, minWidth : 635 }}>
      <Pane
        variant="dashboardCardCustomBigHeader">
        <Flex variant="rowSpaceBetween">
          <Text variant="tableHeader">SS & PS Shells</Text>
        </Flex>
      </Pane>
      <div
        style={{
          height : '100%',
        }}>
        <TableV2
          variant="shellsTable"
          className={classNames( S.table, isFullScreen ? S.tableFull : '' )}
          data={data}
          columns={columns}/>
      </div>
    </Pane>
  )
}

export default ShellsTable
